import { render, staticRenderFns } from "./importTask.vue?vue&type=template&id=2b111832&"
import script from "./importTask.vue?vue&type=script&lang=js&"
export * from "./importTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports